<app-fn-ui-navigation-actions-tree [treeConfig]="treeConfig"
                                   [treeModel]="tree?.recentSearches"
                                   [selectedNode]="selectedNode"
                                   [leafActions]="menuActions"
                                   (nodeActionClicked)="onMenuItemClick($event)">
</app-fn-ui-navigation-actions-tree>
